export const currency = [
    { id: '1', label: 'INR ( ₹ )' },
    { id: '2', label: 'DOLLAR ( $ )' },
];